// https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
// these are populated by need.
export default {
  US: 'US', // United States
};
